import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { FullPageLoading } from "@/components/full-page-loading";
import { useAuth } from "@/context/auth-context";

export const Route = createFileRoute("/_auth-init-space")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    await context.auth.initializationEffect();
  },
  pendingComponent: () => <FullPageLoading text="Preparing user session..." />,
  pendingMs: 0,
});

function RouteComponent() {
  const auth = useAuth();
  const initializationState = useStore(auth.initializationStore, (s) => s);

  if (initializationState !== "ready") {
    return <FullPageLoading text="Logging out..." />;
  }

  return <Outlet />;
}
